enum CoreSpaceIncludes {
    Properties = "properties",
    Values = "values",
    DataTypes = "dataTypes",
    Tags = "tags"
}

export default CoreSpaceIncludes;